/* UserSessionStorage.js */

'use strict';
const UserRemoteStorageBase = require("./UserRemoteStorage");

/**
 * Local UserSessionStorage class,
 * stores the local instance of the window.sessionStorage,
 * and methods to work with it.
 * 
 * Should be created with UserDataStorageFactory class method
 * getSessionStorageInstance(storageRootName, storageKey)
 */
class UserSessionStorage extends UserRemoteStorageBase {
    constructor(storageRootName, storageKey, userSession, logger) {
        super(storageRootName, storageKey, userSession, logger);

        this._storageKey = storageKey ? storageKey : 'tmpSection';
        this._storageRootName = storageRootName ? storageRootName : 'system';
        this._userSession = userSession;
        this._logger = logger;

        this._storageName = this.getStorageName(this._storageKey);

        this._storage = window.sessionStorage;
        this._storageData = this.getStorageData(storageKey);
    }

    setData(data, key, force = false) {
        let keyValueData = {},
            storageName = this._storageName;

        if (key && typeof key === 'string') {
            if (this._userSession) {
                keyValueData[key] = Object.assign(data, {
                    sessionToken: this._userSession.token
                });
            } else {
                keyValueData[key] = data;
            }
        }

        const userData = force ? data : Object.assign({}, this._storageData, keyValueData);
        this._storageData[key] = userData;

        this.updateStorage(keyValueData, storageName);
    }

    updateStorage(keyValueData, storageName) {
        const storage = this.getStorageData(storageName);
        let data = Object.assign({}, storage, keyValueData);

        if (typeof data !== 'string') {
            data = JSON.stringify(data);
        }

        this._storage.setItem(storageName, data);
    }

    getStorageData(storageName) {
        let storageData;

        try {
            storageData = this._storage[storageName] || '{}';
            if (typeof storageData === 'string') {
                storageData = JSON.parse(storageData);
            }
        } catch (e) {
            this._logger.warn({error: e}, "UserSessionStorage.getStorageData() - Can't get storage data, for storage - " + storageName);
            storageData = {};
        }
        return storageData;
    }

}

module.exports = UserSessionStorage;